<template>
  <path :class="pathClasses"
        :d="pathDrawn"
        :transform="centerTransform"></path>
</template>

<script>
  export default {
    props: {
      addPaddingToZero: Boolean,
      bottomLeft: Boolean,
      bottomRight: Boolean,
      centerTransform: String,
      height: Number,
      pathClasses: String,
      radius: [Number, String],
      topLeft: Boolean,
      topRight: Boolean,
      width: Number,
      x: Number,
      y: Number,
    },

    name: 'PathBar',

    components: {
    },

    data() {
      return {
      }
    },

    methods: {
    },

    created() {

    },

    mounted() {
    },

    computed: {
      pathDrawn: function() {
        // from: https://stackoverflow.com/questions/12115691/svg-d3-js-rounded-corner-on-one-corner-of-a-rectangle
        const r = parseInt(this.radius)
        let roundedRect
        roundedRect  = `M ${(this.x + r)},${this.y}h${(this.width - 2*r)}`
        roundedRect += this.topRight ? `a${r},${r} 0 0 1 ${r},${r}` : `h${r}v${r}`
        roundedRect += `v${(this.height - 2*r)}`
        roundedRect += this.bottomRight ? `a${r},${r} 0 0 1 ${-r},${r}` : `v${r}h${-r}`
        roundedRect += `h${(2*r - this.width)}`
        roundedRect += this.bottomLeft ? `a${r},${r} 0 0 1 ${-r}, ${-r}` : `h${-r}v${-r}`
        roundedRect += `v${(2*r - this.height)}`
        roundedRect += this.topLeft ? `a${r},${r} 0 0 1 ${r},${-r}` : `v${-r}h${r}`
        roundedRect += 'z'
        return roundedRect
      }
    },
  }
</script>